import { Attr, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class ProgramAiring extends ApplicationRecord {
  static jsonapiType = "program_airings";

  @Attr() description: string;

  @Attr() endTime: number;

  @Attr() name: string;

  @Attr() startTime: number;
}

export default ProgramAiring;
